/**
 * Persist/delete/retrieve data to/from local storage, falling back to cookies if the browser does not support local storage
 *
 * Local Storage:
 *  persist: { key1: val1, key2: val2 }
 * Cookie:
 *   persist-key1=val1; persist-key2=val2
 */
import { getLocalStorageItemAsObject, saveKeyValToLocalStorage } from "./utils";

const PERSIST_KEY = "persist";

export const persist = (key, value) => {
  try {
    const currentObj = getLocalStorageItemAsObject(PERSIST_KEY);
    currentObj[key] = value;
    saveKeyValToLocalStorage(PERSIST_KEY, currentObj);
  } catch (e) {}
};

export const remove = key => {
  try {
    const currentObj = getLocalStorageItemAsObject(PERSIST_KEY);
    delete currentObj[key];
    saveKeyValToLocalStorage(PERSIST_KEY, currentObj);
  } catch (e) {}
};

/**
 * @return object e.g. { key1: val2, key2: val2 }, regardless of storage mode
 */
export const getPersistedDataAsObj = () => {
  try {
    return getLocalStorageItemAsObject(PERSIST_KEY);
  } catch (e) {
    return {};
  }
};
